import { api } from 'api/api';
const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

const useViewModalNotificacao = (props) => {

    const handleReadNotification = async (id) => {
      try{
        await api(`${ENDPOINT}/cache/schedule-changes/${id}/read`, {
          method: 'PATCH',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
        })
        props.refetch();
      } catch (error) {
        console.log(error);
      }
    };
  return {
    handleReadNotification
  };
};

export default useViewModalNotificacao;
